/**
 * Servicio para gestionar el favicon dinámicamente
 */
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ASSETS_PATHS } from '../constants/assets-paths';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  private renderer: Renderer2;
  private faviconElement: HTMLLinkElement | null = null;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.faviconElement = this.document.querySelector('link[rel="icon"]');
  }

  /**
   * Establece el favicon por defecto
   */
  setDefaultFavicon(): void {
    this.setFavicon(ASSETS_PATHS.IMAGES.FAVICON);
  }

  /**
   * Establece un favicon personalizado
   * @param url Ruta al favicon
   * @param type Tipo MIME del favicon (por defecto image/svg+xml)
   */
  setFavicon(url: string, type: string = 'image/svg+xml'): void {
    if (!this.faviconElement) {
      this.faviconElement = this.renderer.createElement('link');
      this.renderer.setAttribute(this.faviconElement, 'rel', 'icon');
      this.renderer.appendChild(this.document.head, this.faviconElement);
    }

    this.renderer.setAttribute(this.faviconElement, 'type', type);
    this.renderer.setAttribute(this.faviconElement, 'href', url);
  }

  /**
   * Establece un favicon con un contador de notificaciones
   * @param count Número de notificaciones
   */
  setNotificationFavicon(count: number): void {
    if (count <= 0) {
      this.setDefaultFavicon();
      return;
    }

    // Crear un favicon dinámico con un contador
    const canvas = this.document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;
    const ctx = canvas.getContext('2d');
    
    if (ctx) {
      // Dibujar un círculo con el número
      ctx.fillStyle = '#1976d2'; // Color primario
      ctx.beginPath();
      ctx.arc(16, 16, 16, 0, 2 * Math.PI);
      ctx.fill();
      
      // Texto del contador
      ctx.fillStyle = 'white';
      ctx.font = 'bold 20px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(count > 99 ? '99+' : count.toString(), 16, 16);
      
      // Convertir a URL de datos
      const dataUrl = canvas.toDataURL('image/png');
      this.setFavicon(dataUrl, 'image/png');
    }
  }
}
